/**
 * Email capture state mutation helpers.
 *
 * @module
 */

import crypto from 'node:crypto';
import type { CapturedEmail, EmailCtx } from './types.js';

/** Cap retained captures so a runaway send loop cannot grow state unbounded. */
const MAX_RETAINED_EMAILS = 500;

export function record(
  ctx: EmailCtx,
  email: Omit<CapturedEmail, 'id' | 'receivedAt'>
): CapturedEmail {
  const captured: CapturedEmail = {
    id: crypto.randomUUID(),
    receivedAt: new Date().toISOString(),
    ...email,
  };
  ctx.state.sentEmails.push(captured);
  if (ctx.state.sentEmails.length > MAX_RETAINED_EMAILS) {
    ctx.state.sentEmails.splice(0, ctx.state.sentEmails.length - MAX_RETAINED_EMAILS);
  }

  const recipientCount = email.to.length + email.cc.length + email.bcc.length;
  ctx.log(
    'info',
    `[${email.provider}] captured email ${captured.id} for ${recipientCount} recipient(s)`
  );
  return captured;
}
